import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import PondWrap from './PondWrap';
import HeadingH2 from '../common/HeadingH2';
import ErrorBoundary from '../../ErrorBoundary';

const Title = styled.div`
  h2 {
    line-height: 1;
  }
  h2 span {
    color: #10758f;
    font-size: 3.5rem;
    line-height: 1.3;
  }
  img {
    width: 100%;
  }
  .pull-up {
    margin-top: -50px;
    margin-bottom: 20px;
  }
`;

function PondTitle(props) {
  return (
    <ErrorBoundary>
      <PondWrap>
        <Title
          id="pond"
          className="pond-pond-title uk-background-default-trans uk-border-top-primary uk-box-shadow-medium"
        >
          <HeadingH2 tagline={props.tagline}>
            <span>{props.title}</span>
            <div className="pull-up">
              <br />
              {props.subtitle1}
              <br />
              {props.subtitle2}
              <br />
              {props.subtitle3}
            </div>
          </HeadingH2>
        </Title>
      </PondWrap>
    </ErrorBoundary>
  );
}

PondTitle.propTypes = {
  title: PropTypes.string,
  subtitle1: PropTypes.string,
  subtitle2: PropTypes.string,
  subtitle3: PropTypes.string,
  tagline: PropTypes.string,
};

export default PondTitle;



// WEBPACK FOOTER //
// ./src/features/pond/PondTitle.js